import type { InputHTMLAttributes } from "react";
import { useId } from "react";
import type { FlexDirection } from "../../../styling/theme";
import type { FieldOption } from "../../../types/form";
import { Fieldset } from "../../form-fields/components/fieldset";
import { Legend } from "../../form-fields/components/legend";
import { RadioButton } from "../../form-fields/components/radio";
import { FormControlLabel } from "../../form-fields/form-control-label";
import { Stack } from "../../stack";
import { Text } from "../../typography";
import { useFieldContext } from "../form/form-context";
import { FieldInfo } from "./fieldinfo";

type Props = InputHTMLAttributes<HTMLInputElement> & {
	options: FieldOption[];
	legend?: string;
	description?: string;
	direction?: FlexDirection;
};

export const RadioGroupField = ({ options, legend, description, direction, onChange }: Props) => {
	const field = useFieldContext<string>();
	const describedById = useId();
	const hasSubmitFailed = field.state.meta.errors.length > 0;
	return (
		<Stack gap={2}>
			<Fieldset
				aria-invalid={hasSubmitFailed}
				aria-describedby={hasSubmitFailed ? describedById : undefined}
			>
				{!!legend && <Legend>{legend}</Legend>}
				<Stack gap={2} align="start">
					{!!description && <Text className="text-dense">{description}</Text>}

					<Stack gap={2} direction={direction}>
						{options.map((option) => {
							return (
								<FormControlLabel label={option.label} key={option.value}>
									<RadioButton
										checked={field.state.value === option.value}
										name={field.name}
										value={option.value}
										onChange={(event) => onChange?.(event) || field.handleChange(option.value)}
									/>
								</FormControlLabel>
							);
						})}
					</Stack>
				</Stack>
			</Fieldset>
			<FieldInfo field={field} />
		</Stack>
	);
};
